// JourneyStopWatcher — lives in App.tsx, watches the current route.
// When the active journey has a stop matching the current location,
// marks it read after 8s dwell. One component handles all stops across
// all journeys so individual pages don't need per-stop markRead calls.

import { useEffect } from "react";
import { useLocation } from "wouter";
import { useJourney } from "../hooks/useJourney";
import { getJourney } from "../data/journeys/index";

export default function JourneyStopWatcher() {
  const [location] = useLocation();
  const { activeJourneyId, markRead, isRead } = useJourney();

  useEffect(() => {
    if (!activeJourneyId) return;
    const journey = getJourney(activeJourneyId);
    if (!journey) return;

    const stop = journey.stops.find((s) => s.href === location);
    if (!stop || isRead(stop.id)) return;

    const t = window.setTimeout(() => markRead(stop.id), 8000);
    return () => window.clearTimeout(t);
  }, [location, activeJourneyId, markRead, isRead]);

  return null;
}
